module.exports = __webpack_public_path__ + "img/IMG_0914.fbabab33.png";